import Image from 'next/image'
import styled from 'styled-components'

import adLogoImg from '../../../assets/seen-on-logos/ad-logo.png'
import atLogoImg from '../../../assets/seen-on-logos/at-logo.png'
import biLogoImg from '../../../assets/seen-on-logos/bi-logo.png'
import cbLogoImg from '../../../assets/seen-on-logos/cb-logo.png'
import ftLogoImg from '../../../assets/seen-on-logos/ft-logo.png'
import hgLogoImg from '../../../assets/seen-on-logos/hg-logo.png'
import mittrLogoImg from '../../../assets/seen-on-logos/mittr-logo.png'
import rcLogoImg from '../../../assets/seen-on-logos/rc-logo.png'
import yLogoImg from '../../../assets/seen-on-logos/y-logo.png'

const SectionWrapper = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  padding: 0 30px;
  height: 120px;
  background: white;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  box-sizing: border-box;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1200px) {
    gap: 30px;
    padding: 0 20px;
    height: 80px;
    justify-content: flex-start;
  }
`

const Label = styled.span`
  color: black;
  font-size: 20px;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;

  @media (max-width: 1200px) {
    font-size: 12px;
  }
`

const LogoWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    object-fit: contain;
  }

  @media (max-width: 1200px) {
    max-width: 60px;
    max-height: 30px;

    img {
      width: auto;
      height: auto;
      max-width: 60px;
      max-height: 30px;
    }
  }
`

const AsSeenOnSection = () => {
  return (
    <SectionWrapper>
      <Label>As Seen On...</Label>
      <LogoWrapper>
        <Image src={biLogoImg} width={79} height={32} alt="Business Insider" />
      </LogoWrapper>
      <LogoWrapper>
        <Image src={mittrLogoImg} width={76} height={38} alt="MIT Technology Review" />
      </LogoWrapper>
      <LogoWrapper>
        <Image src={atLogoImg} width={114} height={41} alt="Apartment Therapy" />
      </LogoWrapper>
      <LogoWrapper>
        <Image src={adLogoImg} width={110} height={40} alt="Architectural Digest" />
      </LogoWrapper>
      <LogoWrapper>
        <Image src={hgLogoImg} width={96} height={37} alt="House & Garden" />
      </LogoWrapper>
      <LogoWrapper>
        <Image src={ftLogoImg} width={132} height={31} alt="Furniture Today" />
      </LogoWrapper>
      <LogoWrapper>
        <Image src={rcLogoImg} width={104} height={19} alt="realtor.com" />
      </LogoWrapper>
      <LogoWrapper>
        <Image src={cbLogoImg} width={84} height={25} alt="Coldwell Banker" />
      </LogoWrapper>
      <LogoWrapper>
        <Image src={yLogoImg} width={97} height={26} alt="Yahoo" />
      </LogoWrapper>
    </SectionWrapper>
  )
}

export default AsSeenOnSection
